'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.wallet = void 0;
var tslib_1 = require("tslib");
var adapter_1 = require("../adapter");
var signup_1 = require("../adapter/users/signup");
var util_1 = require("../util");
var balance_1 = require("../util/balance");
var transport_1 = require("../transport");
var Wallet = /** @class */ (function () {
    function Wallet() {
    }
    /**
     * GetGamingAccounts returns the user wallet
     */
    Wallet.prototype.getGamingAccounts = function () {
        return adapter_1.adapter.wallet.getGamingAccounts();
    };
    Wallet.prototype.getGamingCoreXAccounts = function () {
        return adapter_1.adapter.wallet.getGamingCoreXAccounts();
    };
    Wallet.prototype.getGalleonPaymentMethods = function () {
        return adapter_1.adapter.wallet.getGalleonPaymentMethods();
    };
    /**
     * Get aggregated bonuses from gig magic and gig core
     */
    Wallet.prototype.getApplicableBonuses = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, orderedResult;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.wallet.getApplicableBonuses()];
                    case 1:
                        result = _a.sent();
                        orderedResult = result.sort(function (itemA, itemB) {
                            // If both have isPriority as true then order by priority number
                            if (itemA.isPriority && itemB.isPriority) {
                                return itemA.priority - itemB.priority;
                            }
                            // Only 'itemA' isPriority is true
                            if (itemA.isPriority && !itemB.isPriority) {
                                return -1;
                            }
                            // Only 'itemB' isPriority is true
                            if (!itemA.isPriority && itemB.isPriority) {
                                return 1;
                            }
                            // When isPriority is false we keep the order coming from the response
                            return 0;
                        });
                        return [2 /*return*/, result ? orderedResult : []];
                }
            });
        });
    };
    /**
     * Get remaining deposit limit
     * The least value between daily, weekly and monthly limits
     */
    Wallet.prototype.getDepositRemainingLimits = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.wallet.getDepositRemainingLimits()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Forfeit user bonus
     */
    Wallet.prototype.forfeitBonus = function (bonusId) {
        var params = { userBonusId: bonusId };
        return adapter_1.adapter.wallet.forfeitBonus(params);
    };
    /**
     * Get granted bonuses
     */
    Wallet.prototype.getGrantedBonuses = function () {
        return adapter_1.adapter.wallet.getGrantedBonuses();
    };
    Wallet.prototype.redeemSweepCoins = function (amount) {
        return adapter_1.adapter.wallet.redeemSweepCoins(amount);
    };
    /**
     * Get transaction history
     */
    Wallet.prototype.getTransactionHistory = function (from, to) {
        return this.splitDatedRequest(from, to, function (newFrom, newTo) {
            var params = { from: newFrom, to: newTo };
            return adapter_1.adapter.wallet.getTransactionHistory(params);
        });
    };
    /**
     * Get games transaction history
     */
    Wallet.prototype.getGamesTransactions = function (from, to) {
        return this.splitDatedRequest(from, to, function (newFrom, newTo) {
            var params = { from: newFrom, to: newTo };
            return adapter_1.adapter.wallet.getGamesTransactions(params);
        });
    };
    /**
     * Get betting history total net wins
     */
    Wallet.prototype.getBettingHistoryTotalNetWins = function (from, to) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var params;
            return tslib_1.__generator(this, function (_a) {
                params = {
                    settledFrom: util_1.formatDate(from),
                    settledTo: util_1.formatDate(to),
                };
                return [2 /*return*/, adapter_1.adapter.wallet.getBettingHistoryTotalNetWins(params)];
            });
        });
    };
    /**
     * Gets a list of transactions and odd values conforming to the
     * given search parameters.
     * @param params
     */
    Wallet.prototype.getBettingHistory = function (params) {
        var normalized = tslib_1.__assign(tslib_1.__assign({}, params), { settledDateFrom: util_1.formatDate(params.settledDateFrom), settledDateTo: util_1.formatDate(params.settledDateTo) });
        if (params.placedDateFrom) {
            normalized.placedDateFrom = util_1.formatDate(params.placedDateFrom);
        }
        if (params.placedDateTo) {
            normalized.placedDateTo = util_1.formatDate(params.placedDateTo);
        }
        return adapter_1.adapter.wallet.getBettingHistory(normalized);
    };
    /**
     * Get bonus history
     */
    Wallet.prototype.getBonusesHistory = function (from, to) {
        return this.splitDatedRequest(from, to, function (newFrom, newTo) {
            var params = { from: newFrom, to: newTo };
            return adapter_1.adapter.wallet.getBonusesHistory(params);
        });
    };
    /**
     * Returns a list of 7days, 30 days, lifetime deposits made by the currently
     * logged in user
     */
    Wallet.prototype.getLifetimeDeposits = function () {
        return adapter_1.adapter.wallet.getLifetimeDeposits();
    };
    /**
     * Aggregates and computes the overall balance split across
     * all available gaming wallet accounts
     */
    Wallet.prototype.getComputedBalance = function (currency) {
        if (currency === void 0) { currency = signup_1.Currency.EUR; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isCorex, accounts, accounts, initialBalance, balance;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isCorex = transport_1.transport.isCoreX();
                        if (!isCorex) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getGamingCoreXAccounts()];
                    case 1:
                        accounts = _a.sent();
                        return [2 /*return*/, {
                                accounts: accounts,
                                balance: balance_1.getUserBalance(accounts, currency),
                            }];
                    case 2: return [4 /*yield*/, this.getGamingAccounts()];
                    case 3:
                        accounts = (_a.sent()).accounts;
                        initialBalance = {
                            balance: 0,
                            realBalance: 0,
                            bonusBalance: 0,
                            bonusRealMoneyBalance: 0,
                            bonusBonusMoneyBalance: 0,
                        };
                        balance = accounts
                            .filter(function (account) { return account.currency === currency; })
                            .reduce(function (prev, account) {
                            var amount = account.amount, bonusMoney = account.bonusMoney, realBonusMoney = account.realBonusMoney, isBonusAccount = account.isBonusAccount;
                            return Object.assign(prev, {
                                balance: prev.balance + amount,
                                realBalance: isBonusAccount
                                    ? prev.realBalance
                                    : prev.realBalance + amount,
                                bonusBalance: isBonusAccount
                                    ? prev.bonusBalance + amount
                                    : prev.bonusBalance,
                                bonusRealMoneyBalance: prev.bonusRealMoneyBalance +
                                    ((isBonusAccount && realBonusMoney) || 0),
                                bonusBonusMoneyBalance: prev.bonusBonusMoneyBalance +
                                    ((isBonusAccount && bonusMoney) || 0),
                            });
                        }, initialBalance);
                        return [2 /*return*/, {
                                accounts: accounts,
                                balance: balance,
                            }];
                }
            });
        });
    };
    /**
     * Splits a `to` and `from` dated request into
     * multiple requests that GiG Core can handle (only accepts 60 days)
     * TODO: MAGIC-675 Remove once implemented magic side.
     * Use a chained request to not saturate the server with a Promise.all
     * @param from The original from date
     * @param to The original to date
     * @param handler Function that gets called for each new date range
     * @param maxDays defaults to 60 days. The max days IGC can handle
     */
    Wallet.prototype.splitDatedRequest = function (from, to, handler, maxDays) {
        if (maxDays === void 0) { maxDays = 60; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var requests, res, requests_1, requests_1_1, request, currentResponse, e_1_1;
            var e_1, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        requests = util_1.chunkDateRange(from, to, maxDays).map(function (_a) {
                            var _b = tslib_1.__read(_a, 2), chunkedFrom = _b[0], chunkedTo = _b[1];
                            return function () {
                                return handler(new Date(chunkedFrom), new Date(chunkedTo));
                            };
                        });
                        res = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, 7, 8]);
                        requests_1 = tslib_1.__values(requests), requests_1_1 = requests_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!requests_1_1.done) return [3 /*break*/, 5];
                        request = requests_1_1.value;
                        return [4 /*yield*/, request()];
                    case 3:
                        currentResponse = _b.sent();
                        res = currentResponse.concat(res);
                        _b.label = 4;
                    case 4:
                        requests_1_1 = requests_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (requests_1_1 && !requests_1_1.done && (_a = requests_1.return)) _a.call(requests_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/, res];
                }
            });
        });
    };
    return Wallet;
}());
exports.wallet = new Wallet();
